import 'tippy.js/dist/tippy.css'
import 'tippy.js/animations/shift-away.css'
import 'tippy.js/themes/light-border.css'

import { Controller } from '@hotwired/stimulus'
import tippy from 'tippy.js'

// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = [
    'button',
    'source',
  ]

  declare readonly buttonTarget: HTMLElement
  declare readonly hasButtonTarget: boolean
  declare readonly sourceTarget: HTMLElement

  static values = {
    successClass: String,
    successContent: String,
    successDuration: { type: Number, default: 1500 },
    useSuccessTooltip: { type: Boolean, default: false },
  }

  declare successClassValue: string
  declare successContentValue: string
  declare successDurationValue: number
  declare useSuccessTooltipValue: boolean

  originalClass?: string
  originalContent?: string
  timeout?: ReturnType<typeof setTimeout>

  connect (): void {
    if (!this.hasButtonTarget) return

    this.originalContent = this.buttonTarget.innerHTML
    this.originalClass = this.buttonTarget.className
  }

  copy (event: Event): void {
    event.preventDefault()

    const text = this.sourceTarget.innerHTML || (this.sourceTarget instanceof HTMLInputElement ? this.sourceTarget.value : '')

    navigator.clipboard.writeText(text).then(() => this.copied())
  }

  copied (): void {
    if (!this.hasButtonTarget) return

    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    if (this.useSuccessTooltipValue) {
      const tooltip = tippy(this.buttonTarget, {
        content: this.successContentValue || 'Copied!',
        theme: 'light-border',
        animation: 'shift-away',
        arrow: true,
        trigger: 'manual',
      })
      tooltip.show()
      this.timeout = setTimeout(() => {
        tooltip.hide()
      }, this.successDurationValue)
    } else {
      if (this.successContentValue) {
        this.buttonTarget.innerHTML = this.successContentValue
      }

      if (this.successClassValue) {
        this.buttonTarget.className = this.successClassValue
      }

      this.timeout = setTimeout(() => {
        this.buttonTarget.className = this.originalClass!
        this.buttonTarget.innerHTML = this.originalContent!
      }, this.successDurationValue)
    }
  }
}
